import React from 'react';
import MarketingForm from '../components/MarketingForm';

const Marketing1 = () => {
  // Icha / Reno
  return <MarketingForm marketingNumber="Reno" phoneNumber="81316118466" />;
};

export default Marketing1;
